import { useState } from 'react';
import { HearingOutcome } from '../types/LegalCase';
import type { ErrorField } from '../types/ErrorField';
import type { AddHearingValue } from './useLegalCaseHearings';

// Campos com binding próprio na tela; qualquer outro 422 do backend cai no bloco residual.
const INLINE_FIELDS = new Set([
    'scheduledAt',
    'heldAt',
    'outcome',
    'outcomeStatus',
    'description',
]);

export const residualErrors = (errorFields: ErrorField[]): ErrorField[] =>
    errorFields.filter((e) => !INLINE_FIELDS.has(e.fieldName));

interface UseLegalCaseHearingFormArgs {
    onSubmit: (value: AddHearingValue) => Promise<boolean>;
}

// Estado e handlers do formulário de audiência, fora do componente (diretriz do repo: sem
// função dentro de função). Centraliza o reset dos campos ao enviar com sucesso. Marcar
// realizada = preencher heldAt (+ outcome).
export default function useLegalCaseHearingForm({ onSubmit }: UseLegalCaseHearingFormArgs) {
    const [scheduledAt, setScheduledAt] = useState('');
    const [heldAt, setHeldAt] = useState('');
    const [outcome, setOutcome] = useState('');
    const [outcomeStatus, setOutcomeStatus] = useState<HearingOutcome | ''>('');
    const [description, setDescription] = useState('');

    const reset = () => {
        setScheduledAt('');
        setHeldAt('');
        setOutcome('');
        setOutcomeStatus('');
        setDescription('');
    };

    // A data marcada é obrigatória (o backend rejeita ausente com 422); só libera o envio
    // quando preenchida.
    const canSubmit = scheduledAt.trim().length > 0;

    const submit = async () => {
        if (!canSubmit) return;
        const ok = await onSubmit({ scheduledAt, heldAt, outcome, outcomeStatus, description });
        if (ok) reset();
    };

    return {
        scheduledAt, setScheduledAt,
        heldAt, setHeldAt,
        outcome, setOutcome,
        outcomeStatus, setOutcomeStatus,
        description, setDescription,
        canSubmit, submit, reset,
    };
}
